import Link from 'next/link';
import { useContext, useEffect, useState } from 'react';
import Popup from 'reactjs-popup';

import { HotelListType } from '../../types/HotelType';
import { getHotelSlug } from '../../utils/slugUtils';
import { ModalTabs } from './modalTabs';

import styles from './modal.module.scss';
import { Hotel_SlugContext, Hotel_SlugContextType } from '../../contexts/Hotel_SlugContext';
import { DataLayerAPI } from '../../api/DataLayerAPI';


type TicketPopupProps = {
  hotel: HotelListType,
  roomsPage: boolean,
}

const dataLayerAPI = new DataLayerAPI()

export function HotelListModal({ hotel, roomsPage}: TicketPopupProps) {


  const [open, setOpen] = useState(false);
  const closeModal = () => setOpen(false);
  const [loading, setLoading] = useState(false)
  const { hotel_slugToContext } = useContext<Hotel_SlugContextType>(Hotel_SlugContext);

  const handleClick = () => {
    setLoading(true)
  }

  let pageClass = `${styles.detailsLink} ${styles.hotelDetailsLink}` ;
  if (roomsPage) {
    pageClass = `${styles.detailsLink} ${styles.hotelDetailsLink} ${styles.roomsPage}` ;
  }

  return (
    <div className={styles.modalLinkSection}>
      <p className={pageClass}>
        <button aria-label={`hotel item ${hotel.title}`}  className={styles.modalLink} onClick={() => setOpen(true)}>
          View Hotel Details
        </button>
      </p>
      <Popup open={open} closeOnDocumentClick modal onOpen={() => dataLayerAPI.logModalAction('Modal Opened','Hotels Index Page',hotel.title)} onClose={() => [dataLayerAPI.logModalAction('Modal Closed','Hotel Index Page',hotel.title), setOpen(false)]}>
        {(close: Function) => (
          <div className={styles.modal}>
            <button className={styles.close} onClick={() => closeModal()}>
              <span className='visuallyHidden'>Close</span>
            </button>
            <div className={styles.popupHeader}>
            </div>
            <ModalTabs hotel={hotel} />
            <div className={styles.popupFooter}>
              {!hotel_slugToContext ?
              <Link
                passHref
                href={{ pathname: `/hotels/${getHotelSlug(hotel.title)}` }}
                legacyBehavior>
                {!loading ? <button onClick={handleClick} className={styles.btn}>View Rooms</button> : <button disabled className={styles.btn}>...Loading</button>}
              </Link>
              : ''
            }
            </div>
          </div>
        )}
      </Popup>
    </div>
  );
}